"use client";

import React from "react";

import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1770))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const Close = createSVGIcon(
  <path
    d="M21.429 2.571 2.572 21.43M2.572 2.571 21.429 21.43"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Close",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "CO1Zce",
      defaultMessage: "Close",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: iconCls(),
  })
);
